import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import StripeConnectSection from '../../components/StripeConnect/StripeConnectSection'
import { ROUTES } from '../../constants/routes'
import useApi from '../../hooks/useApi'
import { useCurrentUser } from '../../hooks/useCurrentUser'
import {
  BUSINESS_VERIFICATION_STATUS_VARIANTS,
  getBusinessVerificationBadgeKey,
  isBusinessStripeVerified,
} from '../../lib/stripeConnect'

export default function BusinessStripeConnectSection({ businessId, ein }) {
  const { t } = useTranslation()
  const { fetchBusiness, fetchUser } = useCurrentUser()
  const {
    createBusinessStripeAccount,
    getBusinessStripeAccountStatus,
    getBusinessStripeOnboardingLink,
  } = useApi()

  const returnUrl = `${window.location.origin}${ROUTES.BUSINESS_ACCOUNT}?stripe_return=true`
  const refreshUrl = `${window.location.origin}${ROUTES.BUSINESS_ACCOUNT}?stripe_refresh=true`

  const handleVerificationComplete = () => {
    fetchBusiness()
    fetchUser()
  }

  const prerequisiteMessage =
    ein?.trim?.()?.length > 0 ? null : t('business.stripe.missingEin')

  if (!businessId) {
    return null
  }

  return (
    <StripeConnectSection
      createStripeAccount={createBusinessStripeAccount}
      entityId={businessId}
      getAccountStatus={getBusinessStripeAccountStatus}
      getBadgeStatusKey={getBusinessVerificationBadgeKey}
      getOnboardingLink={getBusinessStripeOnboardingLink}
      isComplete={isBusinessStripeVerified}
      onVerificationComplete={handleVerificationComplete}
      prerequisiteMessage={prerequisiteMessage}
      refreshUrl={refreshUrl}
      returnUrl={returnUrl}
      statusVariants={BUSINESS_VERIFICATION_STATUS_VARIANTS}
      translationPrefix="business.stripe"
    />
  )
}

BusinessStripeConnectSection.propTypes = {
  businessId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ein: PropTypes.string,
}

BusinessStripeConnectSection.defaultProps = {
  businessId: null,
  ein: '',
}
